<template lang="html">
    <div class="team-work">
        <div class="banner-img">
            <!-- <img width="100%" src="https://static.qyjmed.com/webSite/contactUs/teamwork/bg.png" alt=""> -->
        </div>
        <div class="question">
            <div class="container">
                <h2>是否合作遇到这些问题？</h2>
                <img src="https://static.qyjmed.com/webSite/contactUs/teamwork/question.png" alt="">
            </div>
        </div>
        <!-- 保障 -->
        <div class="safe">
            <h2>我们的保障</h2>
            <div class="container">
                <div class="safe-box">
                    <div @click="tab1(index)" v-for="(item,index) in safe" :key="index" class="safe-content">
                        <img :src="item.img" alt="">
                        <div class="safe-text">
                            <p><img :src="item.imgIcon">{{item.title}}</p>
                            <p>{{item.content}}</p>
                        </div>
                    </div>
                    <!-- <div class="safe-content">
                        <img src="https://static.qyjmed.com/webSite/contactUs/teamwork/img1.png" alt="">
                        <div class="safe-text">
                            <p><img src="https://static.qyjmed.com/webSite/contactUs/teamwork/icon1.png">经销商招商</p>
                            <p>全医佳一站式服务平台为您排忧解难，打通线上线下客户形成新的生态系统！</p>
                        </div>
                    </div>
                    <div class="safe-content">
                        <img src="https://static.qyjmed.com/webSite/contactUs/teamwork/img2.png" alt="">
                        <div class="safe-text">
                            <p><img src="https://static.qyjmed.com/webSite/contactUs/teamwork/icon2.png">软件代理商</p>
                            <p>全医佳医院设备管理软件助您打破医院屏障，开启合作新天地！</p>
                        </div>
                    </div>
                    <div class="safe-content">
                        <img src="https://static.qyjmed.com/webSite/contactUs/teamwork/img3.png" alt="">
                        <div class="safe-text">
                            <p><img src="https://static.qyjmed.com/webSite/contactUs/teamwork/iocn3.png">供应商招商</p>
                            <p>全医佳助您锁定目标客户，掌控第一手行业资源信息，免除您的后顾之忧！</p>
                        </div>
                    </div> -->
                </div>
            </div>
        </div>
        <div class="safe-foot">

        </div>
        <Foot></Foot>
    </div>
</template>

<script>
import Foot from '@/components/Footer.vue'
export default {
  name: 'service',
  data(){
      return{
          safe:[{
              img:'https://static.qyjmed.com/webSite/contactUs/teamwork/img1.png',
              imgIcon:'https://static.qyjmed.com/webSite/contactUs/teamwork/icon1.png',
              title:'经销商招商',
              content:'全医佳一站式服务平台为您排忧解难，打通线上线下客户形成新的生态系统！'
          },{
              img:'https://static.qyjmed.com/webSite/contactUs/teamwork/img2.png',
              imgIcon:'https://static.qyjmed.com/webSite/contactUs/teamwork/icon2.png',
              title:'软件代理商',
              content:'全医佳医院设备管理软件助您打破医院屏障，开启合作新天地！'
          },{
              img:'https://static.qyjmed.com/webSite/contactUs/teamwork/img3.png',
              imgIcon:'https://static.qyjmed.com/webSite/contactUs/teamwork/iocn3.png',
              title:'供应商招商',
              content:'全医佳助您锁定目标客户，掌控第一手行业资源信息，免除您的后顾之忧！'
          }]
      }
  },
  methods:{
      tab1:function(index){
           // this.safe.splice(index, 1, this.safe[index]);
           if(index==0){
               this.safe.splice(2,0,this.safe[0])
               this.safe.shift()
           }else if(index ==1){
               console.log(1)
           }else if(index ==2){
               this.safe.splice(1,0,this.safe[2])
               this.safe.pop()
           }
      }
  },
  components: {
      Foot
  }
}
</script>

<style lang="scss" scoped>
    .team-work{
        .banner-img{
            margin-top: $highlight-height;
            background: url('https://static.qyjmed.com/webSite/contactUs/teamwork/bg.png') center;
            height: 374px;
        }
        .question{
            text-align: center;
            .container{
                h2{
                    color: #262626;
                    font-size: 30px;
                    font-weight: 400;
                    margin-bottom: 50px;
                }
            }
        }
        .safe{
            background: url("https://static.qyjmed.com/webSite/contactUs/teamwork/compare.png") center;
            height: 400px;
            margin-top: 124px;
            h2{
                padding: 80px 0 107px;
                text-align: center;
                font-size: 30px;
                font-weight: 400;
            }
            .container{
                .safe-box{
                    .safe-content{
                        display: inline-block;
                        width: 380px;
                        height: 328px;
                        padding: 10px;
                        background: white;
                        z-index: 10;
                        vertical-align: top;
                        box-shadow: -5px 5px 10px -4px #a09bd850, 5px 5px 10px -4px #a09bd850;
                        cursor: pointer;
                        >img{
                            width: 100%;
                        }
                        .safe-text{
                            img{
                                vertical-align: middle;
                                margin-right: 20px;
                            }
                            p{
                                text-align: center;
                                font-size: 22px;
                                line-height: 32px;
                                color: #4497DD;
                                margin-top: 28px;
                                &:last-child{
                                    font-size: 18px;
                                    color:#333;
                                    margin-top: 20px;
                                    line-height: 36px;
                                    padding:0 30px;
                                }
                            }
                        }
                        &:nth-child(2){
                            margin-left: -150px;
                            position: relative;
                            width: 578px;
                            height: 400px;
                            margin-top: -40px;
                            >img{
                                height: 191px;
                            }
                            .safe-text{
                                p:last-child{
                                    padding:0 120px;
                                }
                            }
                        }
                        &:nth-child(3){
                            margin-left: -120px;
                            z-index: 1;
                            position: absolute;
                        }
                    }
                }
            }
        }
        .safe-foot{
            height: 300px;
        }
    }
</style>
